import Layout from '@/layout'

const route = {
  path: '/warningException',
  component: Layout,
  redirect: '/warningException/index',
  alwaysShow: true, // will always show the root menu
  name: 'warningException',
  meta: {
    title: '异常警告',
    icon: 'diy-YiIhJyGk',
    roles: [
      'adminBusinessErrorLog'
    ]
  },
  children: [
    // 异常记录
    {
      path: '/abnormalList/index',
      component: () => import('@/views/abnormalList/index.vue'),
      name: 'AbnormalList',
      meta: {
        title: '异常记录',
        // icon: 'component',
        roles: [
          'adminBusinessErrorLog.index'
        ]
      }
    },
    // 错误队列
    {
      path: '/errorqueue/index',
      component: () => import('@/views/errorqueue/index.vue'),
      name: 'Errorqueue',
      meta: {
        title: '失败队列',
        // icon: 'component',
        roles: [
          'adminBusinessErrorLog.failedJob'
        ]
      }
    }
    // 错误队列
    // {
    //   path: '/errorqueue/index',
    //   component: () => import('@/views/errorqueue/index.vue'),
    //   name: 'errorqueue',
    //   meta: {
    //     title: '错误队列',
    //     // icon: 'component',
    //     roles: [
    //       'adminBusinessErrorLog.index'
    //     ]
    //   }
    // }
  ]
}

export default route
